import clsx from 'clsx';
import { useAuth } from '../../../../app/modules/auth';
import { HeaderUserMenu } from '../../../partials';

const itemClass = 'ms-1 ms-md-4';

const Navbar = () => {
  const { auth } = useAuth();
  const userName = auth?.name || 'User';
  const firstInitial = userName.charAt(0).toUpperCase();

  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className='cursor-pointer d-flex align-items-center gap-3'
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {/* Full name */}
          <span style={{ fontWeight: 600, fontSize: '14px', color: '#3F4254', whiteSpace: 'nowrap' }}>
            {userName}
          </span>

          {/* Circle avatar with first initial */}
          <div
            style={{
              width: '38px',
              height: '38px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #121E5C 0%, #1e3a8a 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontWeight: 700,
              fontSize: '15px',
              letterSpacing: '0.5px',
              flexShrink: 0,
              boxShadow: '0 2px 8px rgba(18, 30, 92, 0.25)',
            }}
          >
            {firstInitial}
          </div>

          {/* Down arrow */}
          <i
            className='bi bi-chevron-down'
            style={{ fontSize: '12px', color: '#A1A5B7', marginLeft: '-4px' }}
          ></i>
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  );
};

export { Navbar };
